var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { Flex } from '../Flex';
import { Shelf } from '../Shelf';
import { Stack } from '../Stack';
import { Text } from '../Text';
export const RadioButton = (_a) => {
    var { label, errorMessage } = _a, radioProps = __rest(_a, ["label", "errorMessage"]);
    return (React.createElement("label", null,
        React.createElement(Shelf, { as: Text, gap: 1, alignItems: "baseline" },
            React.createElement(StyledWrapper, { minWidth: "18px", height: "18px", flex: "0 0 18px" },
                React.createElement(StyledRadioButton, Object.assign({ type: "radio" }, radioProps)),
                React.createElement(StyledOutline, null)),
            React.createElement(Stack, { gap: 1, flex: 1 },
                React.createElement(Text, { variant: "body1", color: radioProps.disabled ? 'textDisabled' : 'textPrimary' }, label),
                errorMessage && (React.createElement(Text, { variant: "label2", color: "statusCritical" }, errorMessage))))));
};
const StyledOutline = styled.span `
  display: none;
  pointer-events: none;
  position: absolute;
  top: -4px;
  right: -4px;
  bottom: -4px;
  left: -4px;
  border: 2px solid var(--fabric-color-focus);
  border-radius: 20px;
`;
const StyledWrapper = styled(Flex) `
  position: relative;

  &::before {
    content: '.';
    width: 0;
    visibility: hidden;
  }
`;
const StyledRadioButton = styled.input `
  width: 18px;
  height: 18px;
  align-self: center;
  margin: -20px 0;

  &:focus-visible + span {
    display: block;
  }
`;
